






















































































































































































































































































































































































































































































import {Vue, Component, Prop} from 'vue-property-decorator';
import InspectionFirstStep from './InspectionFirstStep.vue';
import InspectionThirdStep from './InspectionThirdStep.vue';
import InspectionSecondStep from './InspectionSecondStep.vue';
import {mapActions, mapGetters} from 'vuex';
import {API, BASE_URL} from '@/services/api/api';
import {getImage, Utils} from '@/utils/Utils';
import moment from 'moment';
import InnerImageZoom from 'vue-inner-image-zoom';
import 'vue-inner-image-zoom/lib/vue-inner-image-zoom.css';
import InspectionDetailsPDF from '@/components/template/InspectionDetailsPDF.vue';
import InspectionDetailsHTML from '@/components/template/InspectionDetailsHTML.vue';

import {extractDetailsFromBase64} from '@/services/api/image';
import canvasMerge from '@/utils/CanvasMerge';

@Component({
  components: {
    InspectionFirstStep,
    InspectionSecondStep,
    InspectionThirdStep,
    InnerImageZoom,
    InspectionDetailsPDF,
    InspectionDetailsHTML,
  },
  methods: {
    ...mapActions([
      'setInspectionData',
      'setInspectionDetailsList',
      'setDeckImage',
      'showSuccessToast',
      'showErrorToast',
    ]),
  },
  computed: {
    ...mapGetters(['getInspectionData']),
  },
})
export default class ViewInspection extends Vue {
  @Prop({default: false}) showOnlyEditBtn!: boolean;
  isScreenLoading = true;
  inspectionId = this.$route.params.id;
  setInspectionData: any;
  showSuccessToast: any;
  showErrorToast: any;
  inspectionData: any;
  inspectionDataCopy: any;
  deckImageURL = '';
  createdDeckImageUrl = '';
  howercontectText = '';
  shipDots = [];
  deckImgLoader = false;
  copyBtnLoader = false;
  deckImageName = '';
  ZoneMasterId: string | null = null;
  modalVisible = false;
  modalTitle = '';
  modalConfimationMsg = '';
  isReadOnly = true;
  printBtnLoader = false;
  inspectionDataInArray = [];
  inspectionCode = '';
  showPrintBtn = false;
  setInspectionDetailsList: any;
  setDeckImage: any;
  inspectionImage = '';

  canDeleteInspection = Utils.manageRoutePermissions('inspection', 4);
  canCreateInspection = Utils.manageRoutePermissions('inspection', 2);
  canEditInspection = Utils.manageRoutePermissions('inspection', 3);

  async mounted() {
    await this.getInspectionDataById();
  }

  async getInspectionDataById() {
    try {
      const response = await API.fetchInspecionById(this.inspectionId);
      const response2 = await API.fetchInspectionDataById(this.inspectionId);

      if (response.data && response2.data) {
        const data2 = response2.data;
        this.inspectionDataCopy = data2;
        this.ZoneMasterId = data2.inspectionPoint.zoneMasterId;

        const data = response.data;
        this.inspectionDataInArray[0] = data;
        this.inspectionData = data;

        this.deckImageURL = await getImage(data.deckImage);
        this.deckImageName = data.deckName;
        this.createdDeckImageUrl = '';
        // this.ZoneMasterId = data.zoneDeckID;
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network Error'});
    } finally {
      this.isScreenLoading = false;
    }
  }

  formatDate(date) {
    return moment(date).format('YYYY-MM-DD');
  }

  async onDownLoadClick() {
    const data = await Utils.downloadImage(this.createdDeckImageUrl || this.deckImageURL, this.deckImageName);

    data.click();
  }

  onEditClick() {
    this.$router.push('/edit-inspection/' + this.inspectionId);
  }

  onDeleteClick() {
    this.modalVisible = true;
    this.modalTitle = 'Delete Confirmation';
    this.modalConfimationMsg = 'Are you sure you want to delete this inspection ?';
    // this.deleteStatus = true;
  }

  async onDeleteConfirm() {
    try {
      const response = await API.deleteInspectionById(this.inspectionId);
      if (response.message) {
        this.showSuccessToast({msg: response.message});
        this.$router.push('/inspection-list');
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.showErrorToast({msg: error});
    }
  }

  onPrintClick() {
    // this.setInspectionDetailsList(this.inspectionDataInArray);
    // this.setDeckImage(this.createdDeckImageUrl);

    this.printBtnLoader = true;
    this.$forceUpdate();

    //

    const ref: any = this.$refs.pdfTemplateRef;
    ref.htmlToPdf();
    // this.$router.push('/print');
  }

  stopBtnLoader() {
    this.printBtnLoader = false;
  }

  async onCopyInspectionClick() {
    this.copyBtnLoader = true;
    try {
      const currentDate = moment(new Date()).format('YYYY-MM-DDTHH:mm:ss');

      const reInspectionDate = moment(new Date()).add(1, 'M').format('YYYY-MM-DDTHH:mm:ss');

      const inspectionCode = await this.getInspectionCode();
      if (inspectionCode === undefined) {
        this.showErrorToast({msg: 'Something went wrong'});
        return;
      } else this.inspectionCode = inspectionCode;

      const attachments = this.inspectionDataCopy.inspectionAttachment;

      const modifyAttachment = await Promise.all(
        attachments.map(async (me) => {
          const filePath = me.filePath.replace(8183, 8185) + me.fileName;
          const blobResponse = await API.convertImgURLToBLob(filePath);
          const base64Url = await Utils.ngxBase64(blobResponse);
          const sendAbleUrl = extractDetailsFromBase64(base64Url).url;
          const fileType = extractDetailsFromBase64(base64Url).imageType;

          return {
            ...me,
            attachmentId: null,
            filePath: sendAbleUrl,
            fileType: fileType,
          };
        })
      );

      // var params = $.extend(true, [], this.inspectionData);
      const params = {...this.inspectionDataCopy};

      const inspectionDetail = params.inspectionDetail;
      inspectionDetail['inspectionDate'] = currentDate;
      inspectionDetail['reInspectionDate'] = reInspectionDate;
      inspectionDetail['inspectionID'] = this.inspectionCode;
      // const details = params;
      params['inspectionAttachment'] = modifyAttachment;

      delete params.deck;

      const response = await API.createInspection(params);
      if (response.data) {
        this.$router.push('/inspection-list');
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network Error'});
      console.error('error', error);
    } finally {
      this.copyBtnLoader = false;
    }
  }

  async getInspectionCode() {
    try {
      const response = await API.fetchInspectionId(this.ZoneMasterId);
      if (response.data) {
        const data = response.data;

        return data.inspectioncode;
      } else {
        this.showErrorToast({msg: response.error});
        return response.error;
      }
    } catch (error) {
      this.showErrorToast({msg: error});
      return error;
    }
  }

  goToEditPage() {
    this.$router.push('/edit-inspection/' + this.inspectionId);
  }

  renderDot() {
    this.shipDots = [];
    if (this.deckImgLoader && this.deckImageURL && this.inspectionDataCopy && this.inspectionData) {
      let imageRef = this.$refs.deckImageRef as HTMLImageElement;
      let tempArray = [this.inspectionDataCopy];
      tempArray.map((inspection) => {
        const points = inspection.additionalInfo;
        const inspectionPoint = inspection.inspectionPoint;
        let x,
          y = null;
        if (inspection.inspectionPoint.isMisc) {
          y = (points.centerFrom + points.centerUpto) / 2;

          let totalFrame = points.frameUpto - points.frameFrom;
          let pixelsCountInZone = points.zoneEndPoint - points.zoneStartPoint;
          let pixelsInEachframes = pixelsCountInZone / totalFrame;
          let thisframePosition = points.frameUpto - inspection.inspectionDetail.frameNumber;
          x = points.zoneStartPoint + thisframePosition * pixelsInEachframes;
        } else {
          y = inspectionPoint.location_Y;
          x = inspectionPoint.location_X;
        }

        //
        this.shipDots.push({
          x: x,
          y: y,
          radius: 0.003 * imageRef.naturalWidth,
          color: Utils.getBackgroundColor(this.inspectionData.severity),
          inspectionID: inspection.inspectionId,
          inspectionCode: inspection.inspectionDetail.inspectionID,
        });
      });
      this.mergeImage();
    }
  }

  //make a copy of zone lines and orignal image
  mergeImage() {
    //
    canvasMerge(this.deckImageURL, this.shipDots, {
      crossOrigin: 'anonymous',
      drawType: 'circle',
    }).then((b64) => {
      //
      if (b64 && b64.length > 6) {
        this.createdDeckImageUrl = b64;
      } else {
        console.log('error', b64);
      }
      this.deckImgLoader = false;
      this.showPrintBtn = true;
      this.$forceUpdate();
    });
  }

  deckImageLoad() {
    //

    let _this = this;
    this.deckImgLoader = true;
    this.renderDot();
    // window.onmousemove = function (e) {
    //   const main = e.target as HTMLImageElement;
    //   if (main.classList.contains('shipimg')) {
    //     let content = document.getElementsByClassName('hovercontent');
    //     for (let i = 0; i < content.length; i++) {
    //       content[i].classList.remove('visible');
    //     }
    //     main.style.cursor = 'unset';
    //     _this.howercontectText = '';

    //    }else if (main.classList.contains('deckimg')) {

    //     //	Content of dot which is hovered
    //       let imageRef = _this.$refs.deckImageRef as HTMLImageElement;
    //       let offset = imageRef.getBoundingClientRect();
    //       let x = e.clientX - offset.left;
    //       let y = e.clientY - offset.top;
    //       let cw = main.clientWidth;
    //       let ch = main.clientHeight;
    //       let iw = main.naturalWidth;
    //       let ih = main.naturalHeight;
    //       let posx = (x / cw) * iw;
    //       let posy = (y / ch) * ih;

    //       let detactMouse = false;
    //       _this.shipDots.map((dots) => {
    //         if (
    //           Utils.mouseDistance(dots.x, dots.y, posx, posy) <
    //           0.005 * main.clientWidth
    //         ) {
    //           //
    //           _this.howercontectText = 'Click here to view inspection : '+dots.inspectionCode + " (ID: "+dots.inspectionID+")";
    //           main.style.cursor = 'pointer';
    //           detactMouse = true;
    //         }
    //       });
    //       if(!detactMouse){
    //         main.style.cursor = 'unset';
    //          _this.howercontectText = '';
    //       }
    //   } else {
    //     //	Remove visible class
    //     let content = document.getElementsByClassName('hovercontent');
    //     for (let i = 0; i < content.length; i++) {
    //       content[i].classList.remove('visible');
    //     }
    //   }
    // };
  }
}
